import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import { ApolloCache } from '@apollo/client';
import Form from '../components/form';
import { CREATE_USER, GET_CM_AND_EDITORS } from '../../../queries/user';
import { CREATE_ACCESS } from '../../../queries/userAccess';

const Add = (props: any) => {
  return (
    <Mutation
      mutation={CREATE_USER}
      update={(cache: ApolloCache<any>, response: any) => {
        const usersQuery: { usersContentManagersOrEditors: IUser[] } | null = cache.readQuery({ query: GET_CM_AND_EDITORS });
        cache.writeQuery({
          query: GET_CM_AND_EDITORS,
          data: { usersContentManagersOrEditors: [...(usersQuery?.usersContentManagersOrEditors || []), response?.data?.createUser] },
        });
      }}
    >
      {(createUser: any) => (
        <Mutation mutation={CREATE_ACCESS}>
          {(createAccess: any) => (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <Form query_f={createUser} query_access={createAccess} {...props} />
          )}
        </Mutation>
      )}
    </Mutation>
  );
};

export default Add;
